<template>
  <AccountingPage title="Export comptable">
    <AccountingExportPanel/>
  </AccountingPage>
</template>

<script>
import AccountingPage from "@/accounting/components/AccountingPage.vue";
import AccountingExportPanel from "@/accounting/components/AccountingExportPanel.vue";

export default {
  name: 'AccountingExportView',
  components: {
    AccountingExportPanel,
    AccountingPage,
  },
}
</script>
